import React, { useContext, useEffect, useState } from "react";
import { Fade } from "@mui/material";
import styles from "../../content/pages/homepage.module.css";
import RostersListDisplay from "./RostersListDisplay";
import { Box } from "@mui/material";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import Drawer from "@mui/material/Drawer";
import { WidgetContext } from "src/contexts/WidgetContext";
import { isIOS, isAndroid } from "../../utils/platformUtils";
import { trackFeatureTimeSpent } from "src/utils/analyticsCapFirebase";
import { useAuth0 } from "@auth0/auth0-react";

function RostersPartnerList({ onClose, rostersData, loadingRoster }) {
  const { isDrawerOpen, selectedTeamInfo, setIsDrawerOpen, NON_LOGGED_IN_CONFIG, aiSettings } = useContext(WidgetContext);
  const { user } = useAuth0();
  const [drawerOpenTime, setDrawerOpenTime] = useState<number | null>(null);

  useEffect(() => {
    if (isDrawerOpen && !drawerOpenTime) {
      setDrawerOpenTime(Date.now());
    }
  }, [isDrawerOpen, drawerOpenTime]);

  const handleClose = () => {
    if (drawerOpenTime) {
      const timeSpentMs = Date.now() - drawerOpenTime;
      const timeSpentSeconds = Math.round(timeSpentMs / 1000);
      const currentPlatform = selectedTeamInfo?.platformId || "unknown";
      const authId = user?.sub ?? NON_LOGGED_IN_CONFIG.authId ?? "unknown";

      //   if (timeSpentSeconds > 0) {
      //     trackFeatureTimeSpent(authId, "rosters_section", timeSpentSeconds, currentPlatform);
      //   }
      setDrawerOpenTime(null);
    }

    // Sync close: onClose clears thoughts + closes drawer (avoids sign flash before clear)
    onClose();
  };

  return (
    <>
      <Drawer
        anchor="bottom"
        open={isDrawerOpen}
        hideBackdrop={true}
        sx={{
          pointerEvents: "none",
        }}
        ModalProps={{
          sx: {
            pointerEvents: "auto", // Block background scroll when drawer is open
            zIndex: 1450,
          },
        }}
        PaperProps={{
          sx: {
            width: {
              xs: "100%",
              sm: "720px",
              md: "720px",
              lg: "720px",
            },
            margin: {
              xs: "0",
              sm: "0 auto",
              md: "0 auto",
              lg: "0 auto",
            },
            // height: isIOS || isAndroid ? "calc(100svh - env(safe-area-inset-top) - 56px)" : "calc(100vh  - 56px)",
            height: isIOS || isAndroid
              ? (aiSettings.quan ? "calc(100svh - env(safe-area-inset-top))" : "calc(100svh - env(safe-area-inset-top) - 56px)")
              : (!aiSettings.quan ? "calc(100vh - 56px)" : "100%"), border: `1px solid ${PureLightThemeCaaS.colors.alpha.white[30]}`,
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
          },
        }}
      >
        <Fade in={isDrawerOpen} timeout={700}>
          <Box
            sx={{
              bgcolor: `${PureLightThemeCaaS.colors.alpha.black[100]}`,
              height: "100%",
              position: "relative",
              // Prevent scroll of the parent container; allow vertical scroll in children
              touchAction: "none",
              "& > *": {
                touchAction: "pan-y",
              },
              paddingBottom: isAndroid ? "max(env(safe-area-inset-bottom), 15px)" : "0px",
              pointerEvents: "auto",
            }}
            className={styles.noScrollbar}
          >
            <RostersListDisplay onClose={handleClose} rostersData={rostersData} loadingRoster={loadingRoster} />
          </Box>
        </Fade>
      </Drawer>
    </>
  );
}

export default RostersPartnerList;
